import { render, staticRenderFns } from "./RootApp.vue?vue&type=template&id=2844f9fc&"
import script from "./RootApp.vue?vue&type=script&lang=js&"
export * from "./RootApp.vue?vue&type=script&lang=js&"
import style0 from "./RootApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports